import React, { useEffect, useState } from "react";
import {
    Button,
    Form,
    Input,
    message,
    Modal,
    Space,
    Switch,
    Tag,
    Card,
    Popconfirm,
    Tabs,
    Tooltip,
    Radio,
    Select,
} from "antd";
import Table from "../../Reusable/Table/Table1";
import axios from "axios";
import consts from "../../constant";
import { EditOutlined, DeleteOutlined, SettingOutlined, PlusOutlined, SaveOutlined } from "@ant-design/icons";
import Loadingpage from "../Loadingpage/Loadingpage";

const SpinAndWinSetting = () => {
    const [form] = Form.useForm();
    const [editForm] = Form.useForm();
    const [segmentForm] = Form.useForm();
    const [editSegmentForm] = Form.useForm();
    const [spinAndWinList, setSpinAndWinList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pageLoading, setPageLoading] = useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [isSegmentModalOpen, setIsSegmentModalOpen] = useState(false);
    const [isEditSegmentModalOpen, setIsEditSegmentModalOpen] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [editingSegmentId, setEditingSegmentId] = useState(null);
    const [editingSegmentIndex, setEditingSegmentIndex] = useState(null);
    const [selectedSetting, setSelectedSetting] = useState(null);
    const [activeTab, setActiveTab] = useState("1");
    const [isAddModalOpen, setIsAddModalOpen] = useState(false);
    const [jackpotSettings, setJackpotSettings] = useState(null);
    const [poolSettings, setPoolSettings] = useState(null);
    const [isJackpotSegmentModalOpen, setIsJackpotSegmentModalOpen] = useState(false);
    const [isJackpotEditModalOpen, setIsJackpotEditModalOpen] = useState(false);
    const [editingJackpotSegmentId, setEditingJackpotSegmentId] = useState(null);
    const [editingJackpotSegmentIndex, setEditingJackpotSegmentIndex] = useState(null);
    const [jackpotSegmentForm] = Form.useForm();
    const [editJackpotSegmentForm] = Form.useForm();
    const [poolForm] = Form.useForm();
    const [messageApi, contextHolder] = message.useMessage();

    const fetchSettings = async () => {
        setLoading(true);
        try {
            const { data } = await axios.post(
                `${consts.BackendUrl}/spinWheel/get-trade-settings`,
                { type: "spinAndWin" },
                {
                    headers: {
                        Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
                    },
                }
            );
            if (data?.success && data?.result) {
                const results = Array.isArray(data.result) ? data.result : [data.result];
                setSpinAndWinList(results);
                return results;
            }
            return [];
        } catch (error) {
            console.error("Error fetching settings:", error);
            messageApi.error("Failed to fetch settings");
            return [];
        } finally {
            setLoading(false);
        }
    };

    const fetchJackpotSettings = async () => {
        try {
            const { data } = await axios.post(
                `${consts.BackendUrl}/spinWheel/get-jackpot-settings`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
                    },
                }
            );
            if (data?.success) {
                setJackpotSettings(data.result?.find(i => i?.isActive));
                poolForm.setFieldsValue({
                    pool_type: data.result.spinAndWin?.pool_type || "fixed",
                    jackpot_value: data.result.spinAndWin?.pool_type === "fixed"
                        ? data.result.spinAndWin?.fixed_pool_amount
                        : data.result.spinAndWin?.jackpot_spread
                });
            }
        } catch (err) {
            console.error("Error fetching jackpot settings:", err);
        }
    };

    const fetchPoolSettings = async () => {
        try {
            const { data } = await axios.post(
                `${consts.BackendUrl}/spinWheel/get-pool-settings`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
                    },
                }
            );
            if (data?.success) {
                const settings = Array.isArray(data.result) ? data.result[0] : data.result;
                setPoolSettings(settings);
                poolForm.setFieldsValue({ price: settings?.price });
            }
        } catch (err) {
            console.error("Error fetching pool settings:", err);
        }
    };

    const fetchTabData = async (tabKey = activeTab) => {
        setPageLoading(true);
        try {
            if (tabKey === "1") {
                await fetchSettings();
            } else {
                await Promise.all([fetchJackpotSettings(), fetchPoolSettings()]);
            }
        } finally {
            setPageLoading(false);
        }
    };

    const handleTabChange = (key) => {
        setActiveTab(key);
        fetchTabData(key);
    };

    useEffect(() => {
        const loadInitialData = async () => {
            setPageLoading(true);
            try {
                await Promise.all([
                    fetchSettings(),
                    fetchJackpotSettings(),
                    fetchPoolSettings(),
                ]);
            } finally {
                setPageLoading(false);
            }
        };

        loadInitialData();
    }, []);

    const onFinish = async (values) => {
        if (spinAndWinList.length >= 5) {
            return messageApi.open({
                type: "error",
                content: "Maximum 5 Spin & Win settings allowed",
            });
        }
        setLoading(true);
        try {
            await axios.post(
                `${consts.BackendUrl}/spinWheel/set-trade-settings`,
                {
                    type: "spinAndWin",
                    admin_commission: Number(values.admin_commission),
                    min_amount: Number(values.min_amount),
                    max_amount: Number(values.max_amount),
                    isActive: values.isActive || false,
                    spinAndWin: {
                        jackpot_spread: values.jackpot_spread || "0",
                        pool_type: values.pool_type || "fixed",
                        fixed_pool_amount: values.fixed_pool_amount || "0",
                        max_selection: values.max_selection || "6",
                        spin_settings: []
                    }
                },
                {
                    headers: {
                        Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
                    },
                }
            );
            messageApi.success("Spin & Win setting added successfully");
            form.resetFields();
            fetchSettings();
        } catch (error) {
            messageApi.error(error.response?.data?.message || "Failed to add setting");
        } finally {
            setLoading(false);
        }
    };

    const handleEdit = (record) => {
        setEditingId(record._id);
        editForm.setFieldsValue({
            admin_commission: record.admin_commission,
            min_amount: record.min_amount,
            max_amount: record.max_amount,
            isActive: record.isActive,
            jackpot_spread: record.spinAndWin?.jackpot_spread,
            pool_type: record.spinAndWin?.pool_type || "fixed",
            fixed_pool_amount: record.spinAndWin?.fixed_pool_amount,
            max_selection: record.spinAndWin?.max_selection || "6",
        });
        setIsEditModalOpen(true);
    };

    const onEditFinish = async (values) => {
        if (values.isActive === false && spinAndWinList.find(s => s._id === editingId)?.isActive) {
            return messageApi.warning("At least one configuration must remain active. Please activate another configuration instead.");
        }
        setLoading(true);
        // Preserve existing spin_settings — never overwrite them from the edit form
        const existingRecord = spinAndWinList.find(s => s._id === editingId);
        const existingSpinSettings = existingRecord?.spinAndWin?.spin_settings || [];
        try {
            await axios.post(
                `${consts.BackendUrl}/spinWheel/set-trade-settings`,
                {
                    type: "spinAndWin",
                    id: editingId,
                    admin_commission: Number(values.admin_commission),
                    min_amount: Number(values.min_amount),
                    max_amount: Number(values.max_amount),
                    isActive: values.isActive,
                    spinAndWin: {
                        spin_settings: existingSpinSettings,
                        jackpot_spread: existingRecord?.spinAndWin?.jackpot_spread || '0',
                        pool_type: existingRecord?.spinAndWin?.pool_type || 'fixed',
                        fixed_pool_amount: existingRecord?.spinAndWin?.fixed_pool_amount || '0',
                        max_selection: values.max_selection || "6",
                    }
                },
                {
                    headers: {
                        Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
                    },
                }
            );
            messageApi.success("Spin & Win setting updated successfully");
            setIsEditModalOpen(false);
            fetchSettings();
        } catch (error) {
            messageApi.error(error.response?.data?.message || "Failed to update setting");
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id) => {
        try {
            await axios.post(
                `${consts.BackendUrl}/settings/delete-trade-settings`,
                { id, type: "spinAndWin" },
                {
                    headers: {
                        Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
                    },
                }
            );
            messageApi.success("Spin & Win setting deleted successfully");
            fetchSettings();
        } catch (error) {
            messageApi.error(error.response?.data?.message || "Failed to delete setting");
        }
    };
    const handleStatusToggle = async (record, checked) => {
        const activeConfigs = spinAndWinList.filter((item) => item.isActive);
        if (!checked && activeConfigs.length === 1) {
            return messageApi.warning("At least one configuration must remain active. Please activate another configuration instead.");
        }
        setLoading(true);
        try {
            await axios.post(
                `${consts.BackendUrl}/spinWheel/set-trade-settings`,
                {
                    type: "spinAndWin",
                    id: record._id,
                    isActive: checked,
                    min_amount: record.min_amount,
                    max_amount: record.max_amount,
                    admin_commission: record.admin_commission,
                    spinAndWin: record.spinAndWin
                },
                {
                    headers: {
                        Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
                    },
                }
            );
            messageApi.success(`Configuration ${checked ? 'activated' : 'deactivated'}`);
            fetchSettings();
        } catch (error) {
            messageApi.error("Failed to update status");
        } finally {
            setLoading(false);
        }
    };

    const handleAddSegment = async (values) => {
        if (!selectedSetting) return;
        setLoading(true);
        const newSegments = [...(selectedSetting.spinAndWin?.spin_settings || []), {
            ...values,
            probability: Number(values.probability ?? 10),
            _id: Math.random().toString(36).substr(2, 9)
        }];

        try {
            await axios.post(
                `${consts.BackendUrl}/spinWheel/set-trade-settings`,
                {
                    type: "spinAndWin",
                    id: selectedSetting._id,
                    // Carry all top-level fields so nothing gets wiped
                    isActive: selectedSetting.isActive,
                    min_amount: selectedSetting.min_amount,
                    max_amount: selectedSetting.max_amount,
                    admin_commission: selectedSetting.admin_commission,
                    spinAndWin: {
                        ...selectedSetting.spinAndWin,
                        spin_settings: newSegments
                    }
                },
                {
                    headers: {
                        Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
                    },
                }
            );
            messageApi.success("Wheel segment added successfully");
            setIsSegmentModalOpen(false);
            segmentForm.resetFields();
            const results = await fetchSettings();
            const updated = results.find(s => s._id === selectedSetting._id);
            if (updated) setSelectedSetting(updated);
        } catch (error) {
            messageApi.error(error.response?.data?.message || "Failed to add segment");
        } finally {
            setLoading(false);
        }
    };

    const handleEditSegment = (record, index) => {
        setEditingSegmentId(record._id);
        setEditingSegmentIndex(index);
        editSegmentForm.setFieldsValue({
            label: record.label,
            value: record.value,
            show_counts: record.show_counts || "1",
            rewardType: record.rewardType || "none",
            isFreeSpin: record.isFreeSpin ?? false,
            isWin: record.isWin ?? false,
            winCounts: record.winCounts ?? 0,
            probability: record.probability ?? 10,
            isVisible: record.isVisible ?? true,
        });
        setIsEditSegmentModalOpen(true);
    };

    const onEditSegmentFinish = async (values) => {
        if (!selectedSetting) return;
        setLoading(true);
        const newSegments = selectedSetting.spinAndWin.spin_settings.map((s, idx) =>
            idx === editingSegmentIndex ? { ...s, ...values, probability: Number(values.probability ?? 10) } : s
        );

        try {
            await axios.post(
                `${consts.BackendUrl}/spinWheel/set-trade-settings`,
                {
                    type: "spinAndWin",
                    id: selectedSetting._id,
                    // Carry all top-level fields so nothing gets wiped
                    isActive: selectedSetting.isActive,
                    min_amount: selectedSetting.min_amount,
                    max_amount: selectedSetting.max_amount,
                    admin_commission: selectedSetting.admin_commission,
                    spinAndWin: {
                        ...selectedSetting.spinAndWin,
                        spin_settings: newSegments
                    }
                },
                {
                    headers: {
                        Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
                    },
                }
            );
            messageApi.success("Wheel segment updated successfully");
            setIsEditSegmentModalOpen(false);
            editSegmentForm.resetFields();
            const results = await fetchSettings();
            const updated = results.find(s => s._id === selectedSetting._id);
            if (updated) setSelectedSetting(updated);
        } catch (error) {
            messageApi.error(error.response?.data?.message || "Failed to update segment");
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteSegment = async (segmentId, index) => {
        if (!selectedSetting) return;
        setLoading(true);
        const newSegments = selectedSetting.spinAndWin.spin_settings.filter((s, idx) => idx !== index);

        try {
            await axios.post(
                `${consts.BackendUrl}/spinWheel/set-trade-settings`,
                {
                    type: "spinAndWin",
                    id: selectedSetting._id,
                    // Carry all top-level fields so nothing gets wiped
                    isActive: selectedSetting.isActive,
                    min_amount: selectedSetting.min_amount,
                    max_amount: selectedSetting.max_amount,
                    admin_commission: selectedSetting.admin_commission,
                    spinAndWin: {
                        ...selectedSetting.spinAndWin,
                        spin_settings: newSegments
                    }
                },
                {
                    headers: {
                        Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
                    },
                }
            );
            messageApi.success("Wheel segment deleted successfully");
            const results = await fetchSettings();
            const updated = results.find(s => s._id === selectedSetting._id);
            if (updated) setSelectedSetting(updated);
        } catch (error) {
            messageApi.error(error.response?.data?.message || "Failed to delete segment");
        } finally {
            setLoading(false);
        }
    };
    const handleJackpotSave = async () => {
        const values = poolForm.getFieldsValue();
        const activeConfig = spinAndWinList.find(s => s.isActive);

        if (!activeConfig) {
            return messageApi.error("No active configuration found. Please activate one first.");
        }

        setLoading(true);
        try {
            // 1. Update Trade Configuration (Pool Type) — carry all top-level fields
            await axios.post(
                `${consts.BackendUrl}/spinWheel/set-trade-settings`,
                {
                    type: "spinAndWin",
                    id: activeConfig._id,
                    isActive: true,
                    min_amount: activeConfig.min_amount,
                    max_amount: activeConfig.max_amount,
                    admin_commission: activeConfig.admin_commission,
                    spinAndWin: {
                        ...activeConfig.spinAndWin,
                        pool_type: values.pool_type
                    }
                },
                {
                    headers: {
                        Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
                    },
                }
            );

            // 2. Update Pool Balance (Price)
            await axios.post(
                `${consts.BackendUrl}/spinWheel/set-pool-settings`,
                { id: poolSettings?._id, price: values.price },
                {
                    headers: {
                        Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
                    },
                }
            );

            messageApi.success("Jackpot settings and pool balance updated");
            fetchSettings();
            fetchPoolSettings();
        } catch (err) {
            messageApi.error("Failed to update jackpot settings");
        } finally {
            setLoading(false);
        }
    };

    const handleJackpotStatusUpdate = async (isActive) => {
        setLoading(true);
        try {
            await axios.post(
                `${consts.BackendUrl}/spinWheel/set-jackpot-settings`,
                { id: jackpotSettings?._id, isActive },
                {
                    headers: {
                        Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
                    },
                }
            );
            messageApi.success("Jackpot status updated");
            fetchJackpotSettings();
        } catch (err) {
            messageApi.error("Failed to update jackpot status");
        } finally {
            setLoading(false);
        }
    };

    const handleAddJackpotSegment = async (values) => {
        setLoading(true);
        const newSegments = [...(jackpotSettings?.spin_settings || []), { ...values, probability: Number(values.probability ?? 10) }];
        try {
            await axios.post(
                `${consts.BackendUrl}/spinWheel/set-jackpot-settings`,
                { id: jackpotSettings?._id, spin_settings: newSegments },
                {
                    headers: {
                        Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
                    },
                }
            );
            messageApi.success("Jackpot segment added");
            setIsJackpotSegmentModalOpen(false);
            fetchJackpotSettings();
        } catch (err) {
            messageApi.error("Failed to add jackpot segment");
        } finally {
            setLoading(false);
        }
    };

    const handleEditJackpotSegment = async (values) => {
        setLoading(true);
        const newSegments = jackpotSettings.spin_settings.map((s, idx) => idx === editingJackpotSegmentIndex ? { ...s, ...values, probability: Number(values.probability ?? 10) } : s);
        try {
            await axios.post(
                `${consts.BackendUrl}/spinWheel/set-jackpot-settings`,
                { id: jackpotSettings?._id, spin_settings: newSegments },
                {
                    headers: {
                        Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
                    },
                }
            );
            messageApi.success("Jackpot segment updated");
            setIsJackpotEditModalOpen(false);
            fetchJackpotSettings();
        } catch (err) {
            messageApi.error("Failed to update jackpot segment");
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteJackpotSegment = async (segmentId, index) => {
        setLoading(true);
        const newSegments = jackpotSettings.spin_settings.filter((s, idx) => idx !== index);
        try {
            await axios.post(
                `${consts.BackendUrl}/spinWheel/set-jackpot-settings`,
                { id: jackpotSettings?._id, spin_settings: newSegments },
                {
                    headers: {
                        Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
                    },
                }
            );
            messageApi.success("Jackpot segment deleted");
            fetchJackpotSettings();
        } catch (err) {
            messageApi.error("Failed to delete jackpot segment");
        } finally {
            setLoading(false);
        }
    };


    const settingColumns = [
        {
            title: <span style={{ color: "white" }}>Min Price</span>,
            dataIndex: "min_amount",
            key: "min_amount",
            render: (text) => <span style={{ color: "white" }}>${text}</span>,
        },
        {
            title: <span style={{ color: "white" }}>Max Price</span>,
            dataIndex: "max_amount",
            key: "max_amount",
            render: (text) => <span style={{ color: "white" }}>${text}</span>,
        },
        {
            title: <span style={{ color: "white" }}>Commission</span>,
            dataIndex: "admin_commission",
            key: "admin_commission",
            render: (text) => <span style={{ color: "white" }}>{text}%</span>,
        },
        {
            title: <span style={{ color: "white" }}>Status</span>,
            dataIndex: "isActive",
            key: "isActive",
            render: (isActive, record) => (
                <Switch
                    checked={isActive}
                    onChange={(checked) => handleStatusToggle(record, checked)}
                    checkedChildren="Active"
                    unCheckedChildren="Inactive"
                />
            ),
        },
        {
            title: <span style={{ color: "white" }}>Action</span>,
            key: "action",
            render: (_, record) => (
                <Space size="middle">
                    <Tooltip title="Wheel Segments">
                        <Button
                            icon={<SettingOutlined />}
                            onClick={() => {
                                setSelectedSetting(record);
                                // setActiveTab("2");
                            }}
                        />
                    </Tooltip>
                    <Button icon={<EditOutlined />} onClick={() => handleEdit(record)} />
                    <Popconfirm
                        title={<span style={{ color: "white" }}>Delete the setting</span>}
                        onConfirm={() => handleDelete(record._id)}
                        okText="Yes"
                        cancelText="No"
                        overlayInnerStyle={{
                            backgroundColor: "#000",
                            border: `1px solid ${consts.PrimaryColor}`,
                        }}
                    >
                        <Button icon={<DeleteOutlined />} danger disabled={record.isActive} />
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    const segmentColumns = [
        {
            title: <span style={{ color: "white" }}>Label</span>,
            dataIndex: "label",
            key: "label",
            render: (text) => <span style={{ color: "white", fontWeight: "500" }}>{text}</span>,
        },
        {
            title: <span style={{ color: "white" }}>Value</span>,
            dataIndex: "value",
            key: "value",
            render: (text) => <span style={{ color: "white", fontWeight: "500" }}>{text}</span>,
        },
        {
            title: <span style={{ color: "white" }}>Type</span>,
            key: "type",
            render: (record) => (
                <Space>
                    {record.isFreeSpin && <Tag color="blue">Free Spin</Tag>}
                    {record.isWin && <Tag color="gold">Win</Tag>}
                    {!record.isFreeSpin && !record.isWin && <Tag color="default">Standard</Tag>}
                </Space>
            ),
        },
        {
            title: <span style={{ color: "white" }}>Win Count</span>,
            key: "s",
            render: (record) => (
                <span style={{ color: "white" }}>
                    {record.isWin ? (record.winCounts ?? 0) : <span style={{ color: "rgba(255,255,255,0.3)" }}>—</span>}
                </span>
            ),
        },
        {
            title: <span style={{ color: "white" }}>Probability</span>,
            dataIndex: "probability",
            key: "probability",
            render: (text) => (
                <span style={{ color: consts.PrimaryColor || "#faad14", fontWeight: "600" }}>
                    {text ?? 10}
                </span>
            ),
        },
        {
            title: <span style={{ color: "white" }}>Counts</span>,
            dataIndex: "show_counts",
            key: "show_counts",
            render: (text) => <span style={{ color: "white" }}>{text}</span>,
        },
        {
            title: <span style={{ color: "white" }}>Visible</span>,
            dataIndex: "isVisible",
            key: "isVisible",
            render: (visible) => <Tag color={visible ? "cyan" : "volcano"}>{visible ? "Yes" : "No"}</Tag>,
        },
        {
            title: <span style={{ color: "white" }}>Action</span>,
            key: "action",
            render: (_, record, index) => (
                <Space size="small">
                    <Button icon={<EditOutlined />} size="small" onClick={() => handleEditSegment(record, index)} />
                    <Popconfirm
                        title={<span style={{ color: "white" }}>Delete this segment?</span>}
                        onConfirm={() => handleDeleteSegment(record._id, index)}
                        okText="Yes"
                        cancelText="No"
                        overlayInnerStyle={{
                            backgroundColor: "#000",
                            border: `1px solid ${consts.PrimaryColor}`,
                        }}
                    >
                        <Button icon={<DeleteOutlined />} danger size="small" />
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    const jackpotSegmentColumns = [
        {
            title: <span style={{ color: "white" }}>Label</span>,
            dataIndex: "label",
            key: "label",
            render: (text) => <span style={{ color: "white" }}>{text}</span>,
        },
        {
            title: <span style={{ color: "white" }}>Percentage (%)</span>,
            dataIndex: "perc",
            key: "perc",
            render: (text) => <span style={{ color: "white" }}>{text}%</span>,
        },
        {
            title: <span style={{ color: "white" }}>Probability</span>,
            dataIndex: "probability",
            key: "probability",
            render: (text) => (
                <span style={{ color: consts.PrimaryColor || "#faad14", fontWeight: "600" }}>
                    {text ?? 10}
                </span>
            ),
        },
        {
            title: <span style={{ color: "white" }}>Win</span>,
            dataIndex: "isWin",
            render: (win) => <Tag color={win ? "gold" : "default"}>{win ? "Win" : "Nothing"}</Tag>,
        },
        {
            title: <span style={{ color: "white" }}>Show Counts</span>,
            dataIndex: "show_counts",
            key: "show_counts",
            render: (text) => <span style={{ color: "white" }}>{text}</span>,
        },
        {
            title: <span style={{ color: "white" }}>Win Counts</span>,
            dataIndex: "winCounts",
            key: "winCounts",
            render: (text) => <span style={{ color: "white" }}>{text}</span>,
        },
        {
            title: <span style={{ color: "white" }}>Visible</span>,
            dataIndex: "isVisible",
            render: (vis) => <Tag color={vis ? "cyan" : "volcano"}>{vis ? "Yes" : "No"}</Tag>,
        },
        {
            title: <span style={{ color: "white" }}>Action</span>,
            key: "action",
            render: (_, record, index) => (
                <Space>
                    <Button
                        size="small"
                        icon={<EditOutlined />}
                        onClick={() => {
                            setEditingJackpotSegmentId(record._id);
                            setEditingJackpotSegmentIndex(index);
                            editJackpotSegmentForm.setFieldsValue({
                                label: record.label,
                                perc: record.perc,
                                isWin: record.isWin ?? true,
                                show_counts: record.show_counts || "1",
                                winCounts: record.winCounts,
                                probability: record.probability ?? 10,
                                isVisible: record.isVisible ?? true,
                            });
                            setIsJackpotEditModalOpen(true);
                        }}
                    />
                    <Popconfirm title="Delete?" onConfirm={() => handleDeleteJackpotSegment(record._id, index)}>
                        <Button size="small" icon={<DeleteOutlined />} danger />
                    </Popconfirm>
                </Space>
            ),
        }
    ];

    const tabItems = [
        {
            key: "1",
            label: "Spin and Win",
            children: (
                <div style={{ marginTop: "20px" }}>
                    <Card
                        title={<span style={{ color: "white" }}>Active Spin & Win Configurations</span>}
                        className="card-bg-clr"
                        extra={
                            <Button type="primary" icon={<PlusOutlined />} onClick={() => {
                                form.resetFields();
                                setIsAddModalOpen(true);
                            }}>
                                Add New Config
                            </Button>
                        }
                    >
                        <Table columnsConfig={settingColumns} data={spinAndWinList} className="table-clr" />
                    </Card>

                    {selectedSetting && (
                        <Card
                            title={<span style={{ color: "white" }}>Wheel Segments — Config: {selectedSetting._id}</span>}
                            className="card-bg-clr"
                            style={{ marginTop: "20px" }}
                            extra={
                                <Button type="primary" size="small" icon={<PlusOutlined />} onClick={() => setIsSegmentModalOpen(true)}>
                                    Add Segment
                                </Button>
                            }
                        >
                            <Table columnsConfig={segmentColumns} data={selectedSetting.spinAndWin?.spin_settings || []} className="table-clr" />
                        </Card>
                    )}
                </div>
            )
        },
        {
            key: "2",
            label: "Jackpot",
            children: (
                <div style={{ marginTop: "20px" }}>
                    <Card title={<span style={{ color: "white" }}>Jackpot Settings</span>} className="card-bg-clr" style={{ marginBottom: "20px" }}>
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "30px" }}>
                            <div>
                                <h4 style={{ color: "rgba(255,255,255,0.6)", marginBottom: "15px" }}>Jackpot Execution Mode</h4>
                                <Form form={poolForm} layout="vertical" onFinish={handleJackpotSave}>
                                    <Form.Item label={<span style={{ color: "white" }}>Pool Configuration</span>} name="pool_type">
                                        <Radio.Group style={{ color: "white" }}>
                                            <Radio value="fixed" style={{ color: "white" }}>Fixed Pool</Radio>
                                            {/* <Radio value="progressive" style={{ color: "white" }}>Progressive Spread</Radio> */}
                                        </Radio.Group>
                                    </Form.Item>

                                    <div style={{ display: "flex", gap: "20px", alignItems: "flex-end", flexWrap: "wrap" }}>
                                        <Form.Item label={<span style={{ color: "white" }}>Current Jackpot Pool ($)</span>} name="price" style={{ marginBottom: 0 }}>
                                            <Input className="input-white" style={{ width: "200px" }} />
                                        </Form.Item>
                                        <Button type="primary" htmlType="submit" icon={<SaveOutlined />} loading={loading}>Save Settings</Button>
                                    </div>
                                </Form>
                            </div>
                            {/* <div>
                                <h4 style={{ color: "rgba(255,255,255,0.6)", marginBottom: "15px" }}>Jackpot Status</h4>
                                <Space direction="vertical">
                                    <Switch
                                        checked={jackpotSettings?.isActive}
                                        onChange={handleJackpotStatusUpdate}
                                        checkedChildren="Active"
                                        unCheckedChildren="Inactive"
                                    />
                                    <Tag color={jackpotSettings?.isActive ? "green" : "red"}>
                                        {jackpotSettings?.isActive ? "Jackpot System Live" : "Jackpot System Offline"}
                                    </Tag>
                                </Space>
                            </div> */}
                        </div>
                    </Card>

                    <Card
                        title={<span style={{ color: "white" }}>Jackpot Wheel Segments</span>}
                        className="card-bg-clr"
                        extra={
                            <Button type="primary" size="small" icon={<PlusOutlined />} onClick={() => setIsJackpotSegmentModalOpen(true)}>
                                Add Jackpot Segment
                            </Button>
                        }
                    >
                        <Table
                            columnsConfig={jackpotSegmentColumns}
                            data={jackpotSettings?.spin_settings || []}
                            className="table-clr"
                        />
                    </Card>
                </div>
            )
        }
    ];

    return (
        <div style={{ padding: "20px" }}>
            <Loadingpage isLoading={loading || pageLoading} />
            {contextHolder}
            <div className="display-2 mb-20">
                <h2>Spin & Win Management</h2>
            </div>

            <div className="card-clr">
                <Tabs
                    activeKey={activeTab}
                    onChange={handleTabChange}
                    items={tabItems}
                    className="custom-tabs"
                />
            </div>

            {/* Edit Setting Modal */}
            <Modal
                title={<span style={{ color: "white" }}>Edit Configuration</span>}
                open={isEditModalOpen}
                onCancel={() => setIsEditModalOpen(false)}
                footer={null}
                centered
                className="custom-modal"
                maskStyle={{ backdropFilter: "blur(8px)", backgroundColor: "rgba(0, 0, 0, 0.3)" }}
                styles={{ content: { border: `1px solid ${consts.PrimaryColor}` } }}
            >
                <Form form={editForm} layout="vertical" onFinish={onEditFinish} className="dark-form">
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "15px" }}>
                        <Form.Item label={<span style={{ color: "white" }}>Max Selection</span>} name="max_selection" rules={[{ required: true }]}>
                            <Input className="input-white" style={{ backgroundColor: "#0b1c15", color: "#aff9bb", borderColor: "#fc4420" }} />
                        </Form.Item>
                        <Form.Item label={<span style={{ color: "white" }}>Min Price</span>} name="min_amount" rules={[{ required: true }]}>
                            <Input className="input-white" style={{ backgroundColor: "#0b1c15", color: "white", borderColor: "#1a2a23" }} />
                        </Form.Item>
                        <Form.Item label={<span style={{ color: "white" }}>Max Price</span>} name="max_amount" rules={[{ required: true }]}>
                            <Input className="input-white" style={{ backgroundColor: "#0b1c15", color: "white", borderColor: "#1a2a23" }} />
                        </Form.Item>
                        <Form.Item label={<span style={{ color: "white" }}>Admin Commission (%)</span>} name="admin_commission">
                            <Input type="number" />
                        </Form.Item>
                        <Form.Item label={<span style={{ color: "white" }}>Status</span>} name="isActive" valuePropName="checked">
                            <Switch checkedChildren="Active" unCheckedChildren="Inactive" />
                        </Form.Item>
                    </div>
                    <Button type="primary" htmlType="submit" loading={loading} block icon={<SaveOutlined />} style={{ marginTop: "20px" }}>Update Configuration</Button>
                </Form>
            </Modal>

            {/* Add Setting Modal */}
            <Modal
                title={<span style={{ color: "white" }}>Add New Configuration</span>}
                open={isAddModalOpen}
                onCancel={() => setIsAddModalOpen(false)}
                footer={null}
                centered
                className="custom-modal"
                maskStyle={{ backdropFilter: "blur(8px)", backgroundColor: "rgba(0, 0, 0, 0.3)" }}
                styles={{ content: { border: `1px solid ${consts.PrimaryColor}` } }}
            >
                <Form form={form} layout="vertical" onFinish={async (v) => { await onFinish(v); setIsAddModalOpen(false); }} initialValues={{ isActive: true, max_selection: "6", min_amount: "10", max_amount: "50" }} className="dark-form">
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "15px" }}>
                        <Form.Item label={<span style={{ color: "white" }}>Max Selection</span>} name="max_selection" rules={[{ required: true }]}>
                            <Input className="input-white" />
                        </Form.Item>
                        <Form.Item label={<span style={{ color: "white" }}>Min Price</span>} name="min_amount" rules={[{ required: true }]}>
                            <Input className="input-white" />
                        </Form.Item>
                        <Form.Item label={<span style={{ color: "white" }}>Max Price</span>} name="max_amount" rules={[{ required: true }]}>
                            <Input className="input-white" />
                        </Form.Item>
                        <Form.Item label={<span style={{ color: "white" }}>Admin Commission (%)</span>} name="admin_commission">
                            <Input type="number" />
                        </Form.Item>
                        <Form.Item label={<span style={{ color: "white" }}>Status</span>} name="isActive" valuePropName="checked">
                            <Switch checkedChildren="Active" unCheckedChildren="Inactive" />
                        </Form.Item>
                    </div>
                    <Button type="primary" htmlType="submit" loading={loading} block icon={<PlusOutlined />} style={{ marginTop: "20px" }}>Create Configuration</Button>
                </Form>
            </Modal>

            {/* Add Segment Modal */}
            <Modal
                title={<span style={{ color: "white" }}>Add Wheel Segment</span>}
                open={isSegmentModalOpen}
                onCancel={() => setIsSegmentModalOpen(false)}
                footer={null}
                centered
                className="custom-modal"
                maskStyle={{ backdropFilter: "blur(8px)", backgroundColor: "rgba(0, 0, 0, 0.3)" }}
                styles={{ content: { border: `1px solid ${consts.PrimaryColor}` } }}
            >
                <Form
                    form={segmentForm}
                    layout="vertical"
                    onFinish={handleAddSegment}
                    initialValues={{ isVisible: true, isFreeSpin: false, isWin: false, winCounts: 0, rewardType: "none", show_counts: "1", probability: 10 }}
                    onValuesChange={(changedValues) => {
                        if (changedValues.rewardType) {
                            if (changedValues.rewardType === "none") {
                                segmentForm.setFieldsValue({ value: "0", winCounts: 0 });
                            }
                            if (changedValues.rewardType === "freeSpin") {
                                segmentForm.setFieldsValue({ value: "0", isFreeSpin: true });
                            }
                        }
                    }}
                >
                    <Form.Item label={<span style={{ color: "white" }}>Label (e.g. 5x, 2 Spins)</span>} name="label" rules={[{ required: true }]}>
                        <Input placeholder="Enter label" />
                    </Form.Item>
                    <Form.Item label={<span style={{ color: "white" }}>Value (Numeric or 'jackpot')</span>} name="value" rules={[{ required: true }]}>
                        <Input placeholder="Enter value" />
                    </Form.Item>
                    <Form.Item label={<span style={{ color: "white" }}>Reward Type</span>} name="rewardType">
                        <Select
                            options={[
                                { value: "cash", label: "Cash" },
                                { value: "freeSpin", label: "Free Spin" },
                                { value: "jackpotTicket", label: "Jackpot Ticket" },
                                { value: "multiplier", label: "Multiplier" },
                                { value: "freeCredit", label: "Free Credit" },
                                { value: "none", label: "None" },
                            ]}
                        />
                    </Form.Item>
                    <Form.Item
                        label={<span style={{ color: "white" }}>Wheel Slices (Show Counts)</span>}
                        name="show_counts"
                        rules={[{ required: true, message: "Show Counts is required" }]}
                        tooltip="How many slices this prize occupies visually around the wheel (Default is 1)."
                    >
                        <Input type="number" min={1} placeholder="e.g. 1" />
                    </Form.Item>
                    <Form.Item
                        label={<span style={{ color: "white" }}>Probability / Draw Weight</span>}
                        name="probability"
                        rules={[{ required: true, message: "Probability is required" }]}
                        tooltip="Relative chance of being drawn (e.g. 10, 50, 100). Higher = more frequent."
                    >
                        <Input type="number" min={0} placeholder="e.g. 10" />
                    </Form.Item>
                    <Form.Item noStyle shouldUpdate={(prev, curr) => prev.isWin !== curr.isWin}>
                        {({ getFieldValue }) =>
                            <Form.Item
                                label={<span style={{ color: "white" }}>Win Count</span>}
                                name="winCounts"
                                rules={[
                                    { required: true, message: "Win Count is required" },
                                ]}
                            >
                                <Input type="number" style={{ width: "100%" }} placeholder="e.g. 1" />
                            </Form.Item>
                        }
                    </Form.Item>
                    <div style={{ display: "flex", gap: "20px", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap" }}>
                        <Form.Item noStyle shouldUpdate={(prev, curr) => prev.rewardType !== curr.rewardType}>
                            {({ getFieldValue }) => getFieldValue("rewardType") === "freeSpin" && (
                                <Form.Item label={<span style={{ color: "white" }}>Free Spin</span>} name="isFreeSpin" valuePropName="checked">
                                    <Switch />
                                </Form.Item>
                            )}
                        </Form.Item>
                        <Form.Item label={<span style={{ color: "white" }}>Win</span>} name="isWin" valuePropName="checked">
                            <Switch />
                        </Form.Item>
                        <Form.Item label={<span style={{ color: "white" }}>Visible</span>} name="isVisible" valuePropName="checked">
                            <Switch />
                        </Form.Item>
                    </div>
                    <Button type="primary" htmlType="submit" loading={loading} block icon={<PlusOutlined />} style={{ marginTop: "20px" }}>Add Segment</Button>
                </Form>
            </Modal>

            {/* Edit Segment Modal */}
            <Modal
                title={<span style={{ color: "white" }}>Edit Wheel Segment</span>}
                open={isEditSegmentModalOpen}
                onCancel={() => {
                    setIsEditSegmentModalOpen(false);
                    editSegmentForm.resetFields();
                }}
                footer={null}
                centered
                destroyOnClose={false}
                className="custom-modal"
                maskStyle={{ backdropFilter: "blur(8px)", backgroundColor: "rgba(0, 0, 0, 0.3)" }}
                styles={{ content: { border: `1px solid ${consts.PrimaryColor}` } }}
            >
                <Form
                    form={editSegmentForm}
                    layout="vertical"
                    onFinish={onEditSegmentFinish}
                    onValuesChange={(changedValues) => {
                        if (changedValues.rewardType) {
                            if (changedValues.rewardType === "none") {
                                editSegmentForm.setFieldsValue({ value: "0", winCounts: 0 });
                            }
                            if (changedValues.rewardType === "freeSpin") {
                                editSegmentForm.setFieldsValue({ value: "0", isFreeSpin: true });
                            }
                        }
                    }}
                >
                    <Form.Item label={<span style={{ color: "white" }}>Label</span>} name="label" rules={[{ required: true }]}>
                        <Input style={{ backgroundColor: "#0b1c15", color: "#fff", borderColor: "#fc4420" }} />
                    </Form.Item>
                    <Form.Item label={<span style={{ color: "white" }}>Value</span>} name="value" rules={[{ required: true }]}>
                        <Input style={{ backgroundColor: "#0b1c15", color: "#fff", borderColor: "#fc4420" }} />
                    </Form.Item>
                    <Form.Item label={<span style={{ color: "white" }}>Reward Type</span>} name="rewardType">
                        <Select
                            dropdownStyle={{ backgroundColor: "#0b1c15", color: "#fff" }}
                            style={{ width: "100%" }}
                            options={[
                                { value: "none", label: "None" },
                                { value: "freeSpin", label: "Free Spin" },
                                { value: "jackpotTicket", label: "Jackpot Ticket" },
                                { value: "multiplier", label: "Multiplier" },
                                { value: "freeCredit", label: "Free Credit" },
                                { value: "cash", label: "Free Cash" },
                            ]}
                        />
                    </Form.Item>
                    <Form.Item
                        label={<span style={{ color: "white" }}>Wheel Slices (Show Counts)</span>}
                        name="show_counts"
                        rules={[{ required: true, message: "Show Counts is required" }]}
                        tooltip="How many slices this prize occupies visually around the wheel (Default is 1)."
                    >
                        <Input type="number" min={1} style={{ backgroundColor: "#0b1c15", color: "#fff", borderColor: "#fc4420" }} />
                    </Form.Item>
                    <Form.Item
                        label={<span style={{ color: "white" }}>Probability / Draw Weight</span>}
                        name="probability"
                        rules={[{ required: true, message: "Probability is required" }]}
                        tooltip="Relative chance of being drawn (e.g. 10, 50, 100). Higher = more frequent."
                    >
                        <Input
                            type="number"
                            min={0}
                            style={{ backgroundColor: "#0b1c15", color: "#fff", borderColor: "#fc4420" }}
                            placeholder="e.g. 10"
                        />
                    </Form.Item>
                    <Form.Item noStyle shouldUpdate={(prev, curr) => prev.isWin !== curr.isWin}>
                        {({ getFieldValue }) =>
                            <Form.Item
                                label={<span style={{ color: "white" }}>Win Count</span>}
                                name="winCounts"
                                rules={[
                                    { required: true, message: "Win Count is required" },
                                ]}
                            >
                                <Input
                                    type="number"
                                    style={{ width: "100%", backgroundColor: "#0b1c15", color: "#fff", borderColor: "#fc4420" }}
                                    placeholder="e.g. 1"
                                />
                            </Form.Item>
                        }
                    </Form.Item>
                    <div style={{ display: "flex", gap: "20px", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap" }}>
                        <Form.Item noStyle shouldUpdate={(prev, curr) => prev.rewardType !== curr.rewardType}>
                            {({ getFieldValue }) => getFieldValue("rewardType") === "freeSpin" && (
                                <Form.Item label={<span style={{ color: "white" }}>Free Spin</span>} name="isFreeSpin" valuePropName="checked">
                                    <Switch />
                                </Form.Item>
                            )}
                        </Form.Item>
                        <Form.Item label={<span style={{ color: "white" }}>Win</span>} name="isWin" valuePropName="checked">
                            <Switch />
                        </Form.Item>
                        <Form.Item label={<span style={{ color: "white" }}>Visible</span>} name="isVisible" valuePropName="checked">
                            <Switch />
                        </Form.Item>
                    </div>
                    <Button type="primary" htmlType="submit" loading={loading} block icon={<SaveOutlined />} style={{ marginTop: "20px" }}>Update Segment</Button>
                </Form>
            </Modal>

            {/* Jackpot Segment Modals */}
            <Modal
                title={<span style={{ color: "white" }}>Add Jackpot Prize</span>}
                open={isJackpotSegmentModalOpen}
                onCancel={() => setIsJackpotSegmentModalOpen(false)}
                footer={null}
                centered
                className="custom-modal"
            >
                <Form form={jackpotSegmentForm} layout="vertical" onFinish={handleAddJackpotSegment} initialValues={{ isVisible: true, isWin: true, perc: "1", show_counts: "1", winCounts: "1", probability: 10 }}>
                    <Form.Item label={<span style={{ color: "white" }}>Label (e.g. 10%, Major Win)</span>} name="label" rules={[{ required: true }]}>
                        <Input placeholder="Enter label" />
                    </Form.Item>
                    <Form.Item label={<span style={{ color: "white" }}>Pool Percentage (%)</span>} name="perc" rules={[{ required: true }]}>
                        <Input type="number" placeholder="Enter percentage" />
                    </Form.Item>
                    <Form.Item label={<span style={{ color: "white" }}>Show Counts</span>} name="show_counts" rules={[{ required: true }]}>
                        <Input type="number" placeholder="Enter counts" />
                    </Form.Item>
                    <Form.Item label={<span style={{ color: "white" }}>Win Counts</span>} name="winCounts" rules={[{ required: true }]}>
                        <Input type="number" placeholder="Enter counts" />
                    </Form.Item>
                    <Form.Item
                        label={<span style={{ color: "white" }}>Probability / Draw Weight</span>}
                        name="probability"
                        rules={[{ required: true, message: "Probability is required" }]}
                        tooltip="Relative chance of being drawn (e.g. 10, 50, 100). Higher = more frequent."
                    >
                        <Input type="number" min={0} placeholder="e.g. 10" />
                    </Form.Item>
                    <div style={{ display: "flex", gap: "20px" }}>
                        <Form.Item label={<span style={{ color: "white" }}>Is Win</span>} name="isWin" valuePropName="checked">
                            <Switch />
                        </Form.Item>
                        <Form.Item label={<span style={{ color: "white" }}>Visible</span>} name="isVisible" valuePropName="checked">
                            <Switch />
                        </Form.Item>
                    </div>
                    <Button type="primary" htmlType="submit" loading={loading} block style={{ marginTop: "10px" }}>Save Prize</Button>
                </Form>
            </Modal>

            <Modal
                title={<span style={{ color: "white" }}>Edit Jackpot Prize</span>}
                open={isJackpotEditModalOpen}
                onCancel={() => {
                    setIsJackpotEditModalOpen(false);
                    editJackpotSegmentForm.resetFields();
                }}
                footer={null}
                centered
                destroyOnClose={false}
                className="custom-modal"
            >
                <Form form={editJackpotSegmentForm} layout="vertical" onFinish={handleEditJackpotSegment}>
                    <Form.Item label={<span style={{ color: "white" }}>Label</span>} name="label" rules={[{ required: true }]}>
                        <Input style={{ backgroundColor: "#0b1c15", color: "#fff", borderColor: "#fc4420" }} />
                    </Form.Item>
                    <Form.Item label={<span style={{ color: "white" }}>Pool Percentage (%)</span>} name="perc" rules={[{ required: true }]}>
                        <Input type="number" style={{ backgroundColor: "#0b1c15", color: "#fff", borderColor: "#fc4420" }} />
                    </Form.Item>
                    <Form.Item label={<span style={{ color: "white" }}>Show Counts</span>} name="show_counts" rules={[{ required: true }]}>
                        <Input type="number" style={{ backgroundColor: "#0b1c15", color: "#fff", borderColor: "#fc4420" }} />
                    </Form.Item>
                    <Form.Item label={<span style={{ color: "white" }}>Win Counts</span>} name="winCounts" rules={[{ required: true }]}>
                        <Input type="number" style={{ backgroundColor: "#0b1c15", color: "#fff", borderColor: "#fc4420" }} />
                    </Form.Item>
                    <Form.Item
                        label={<span style={{ color: "white" }}>Probability / Draw Weight</span>}
                        name="probability"
                        rules={[{ required: true, message: "Probability is required" }]}
                        tooltip="Relative chance of being drawn (e.g. 10, 50, 100). Higher = more frequent."
                    >
                        <Input
                            type="number"
                            min={0}
                            style={{ backgroundColor: "#0b1c15", color: "#fff", borderColor: "#fc4420" }}
                            placeholder="e.g. 10"
                        />
                    </Form.Item>
                    <div style={{ display: "flex", gap: "20px" }}>
                        <Form.Item label={<span style={{ color: "white" }}>Is Win</span>} name="isWin" valuePropName="checked">
                            <Switch />
                        </Form.Item>
                        <Form.Item label={<span style={{ color: "white" }}>Visible</span>} name="isVisible" valuePropName="checked">
                            <Switch />
                        </Form.Item>
                    </div>
                    <Button type="primary" htmlType="submit" loading={loading} block icon={<SaveOutlined />} style={{ marginTop: "10px" }}>Update Prize</Button>
                </Form>
            </Modal>
        </div>
    );
};

export default SpinAndWinSetting;
